import { ModalMessage } from '@zorro/design-system/v2/ModalMessage';

type Props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  employerName: string;
  onSubmit: () => void;
};

export const EmployerDeleteModal = ({
  isOpen,
  setIsOpen,
  employerName,
  onSubmit,
}: Props) => {
  return (
    <ModalMessage
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      variant="negative"
      title={`Delete ${employerName}?`}
      description="Are you sure you want to delete this employer? This action cannot be undone"
      primaryLabel="Delete"
      onPrimaryAction={onSubmit}
      secondaryLabel="Cancel"
      onSecondaryAction={() => setIsOpen(false)}
    />
  );
};
